import { AjaxFormConfig, IAjaxForm } from './ajax-form.types'
import { AjaxFormComponent } from './ajax-form.component'

export const AjaxForm = {
    create: (form: HTMLFormElement, config: AjaxFormConfig): IAjaxForm => new AjaxFormComponent(form, config),
}
